import axios from 'axios';

const prod = 'https://ecg.medway.com.br/wp-json/acf/v3/';
const dev = 'https://ecg.medway.com.br/wp-json/acf/v3/';

const apiECG = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? dev : prod,
});

export default apiECG;
